var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgYoutube = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M23.506 2.63A3.007 3.007 0 0 0 21.39.513C19.512 0 12 0 12 0S4.488 0 2.61.494A3.068 3.068 0 0 0 .493 2.63C0 4.507 0 8.402 0 8.402s0 3.914.494 5.772A3.007 3.007 0 0 0 2.61 16.29c1.897.514 9.39.514 9.39.514s7.512 0 9.39-.494a3.007 3.007 0 0 0 2.116-2.116C24 12.316 24 8.422 24 8.422s.02-3.915-.494-5.793ZM9.608 12V4.804l6.247 3.598L9.608 12Z",
  fill: "#FC5A5A"
})));
export { SvgYoutube as ReactComponent };
export default __webpack_public_path__ + "images/youtube.svg";